import { typeOf } from './basics'
import {IObject} from './interface'



export const BASICS = {
  STOP: Symbol('stop'), // 叫停遍历
  BREAK: Symbol('break'), // 跳出当前循环
  CONTINUE: Symbol('continue'),
  TRUE: Symbol('true'),
  FALSE: Symbol('false'),
}

type fnType = (item: IObject, key: any, parent: IObject | null, level: number) => void
/**
 * @description: 像遍历数组一样遍历集合对象，遍历集合对象(像es6的forEach一样不能停止)
 * @param {*} obj 查找的源对象
 * @param {*} fn(value,key,parent,level)：回调函数；value: 遍历到的当前value值，key: 遍历到的当前key，parent: 遍历到的当前对象，level: 遍历源对象的当前层级，开始为0
 * @return {*} 经过操作后的obj对象
 */
export function forEach (obj: IObject, fn: fnType) {
  let sirdar
  const typeDetermineData = typeOf(obj)
  const recursionObj = function (item, key, parent, level, fn) {
    // 递归对象
    sirdar = fn(item, key, parent, level)
    level += 1
    // if(sirdar === BASICS.STOP || sirdar === BASICS.CONTINUE || sirdar === BASICS.BREAK) {
    //   console.log(item, key, parent, level, 'BASICS.STOPBASICS.STOPBASICS.STOPBASICS.STOPBASICS.STOPBASICS.STOPBASICS.STOP')
    // }
    const objKey = Object.keys(item)
    for (const k of objKey) {
      const typeDetermineData = typeOf(item[k])
      if (typeDetermineData === 'object') {
        // 递归对象
        if (sirdar === BASICS.STOP) {
          return
        }
        if (sirdar === BASICS.BREAK) {
          sirdar = ''
          break
        } else if (sirdar === BASICS.CONTINUE) {
          sirdar = ''
          continue
        } else {
          recursionObj(item[k], k, item, level, fn)
        }
      } else if (typeDetermineData === 'array') {
        // 数组递归
        if (sirdar === BASICS.STOP) {
          return
        }
        if (sirdar === BASICS.BREAK) {
          sirdar = ''
          break
        } else if (sirdar === BASICS.CONTINUE) {
          sirdar = ''
          continue
        } else {
          recursionArr(item[k], k, item, level, fn)
        }
      } else if (sirdar === BASICS.STOP) {
        return
      } else if (sirdar === BASICS.BREAK) {
        sirdar = ''
        break
      } else if (sirdar === BASICS.CONTINUE) {
        sirdar = ''
        continue
      } else {
        sirdar = fn(item[k], k, item, level)
      }
    }
  }
  const recursionArr = function (item, key, parent, level, fn) {
    // 递归数组
    sirdar = fn(item, key, parent, level)
    level += 1
    for (const k in item) {
      const typeDetermineData = typeOf(item[k])
      if (typeDetermineData === 'object') {
        if (sirdar === BASICS.STOP) {
          return
        }
        if (sirdar === BASICS.BREAK) {
          sirdar = ''
          break
        } else if (sirdar === BASICS.CONTINUE) {
          sirdar = ''
          continue
        } else {
          recursionObj(item[k], k, item, level, fn)
        }
      } else if (typeDetermineData === 'array') {
        if (sirdar === BASICS.STOP) {
          return
        }
        if (sirdar === BASICS.BREAK) {
          sirdar = ''
          break
        } else if (sirdar === BASICS.CONTINUE) {
          sirdar = ''
          continue
        } else {
          recursionArr(item[k], k, item, level, fn)
        }
      } else {
        if (sirdar === BASICS.STOP) {
          return
        }
        if (sirdar === BASICS.BREAK) {
          sirdar = ''
          break
        } else if (sirdar === BASICS.CONTINUE) {
          sirdar = ''
          continue
        } else {
          sirdar = fn(item[k], k, item, level)
        }
      }
    }
  }
  if (typeDetermineData === 'object') {
    // 递归对象
    recursionObj(obj, undefined, null, 0, fn)
  } else if (typeDetermineData === 'array') {
    // 数组递归
    recursionArr(obj, undefined, null, 0, fn)
  }
  return obj
}
